export class DocumentOutputLocationDTO {
  purpose: number;

  listId?: number;

  listName?: string;

  listUrl?: string;

  providerType?: number;

  connectionId?: number;

  connectionName?: string;

  templateLinkId?: number;

  templateName?: string;

  templateUrl?: string;

  templateInherited: boolean;

  folderDriveItemId?: string;

  folderName?: string;

  folderRule: number;

  folderNameFormat?: string;

  allowedProviders: number[];

  constructor() {
    this.purpose = 0;
    this.templateInherited = false;
    this.folderRule = 0;
    this.allowedProviders = [];
  }
}

export class DocumentOutputLocationStatusDTO {
  locationSet: boolean;

  reachable: boolean;

  writeAccess: boolean;

  templatePresent?: boolean;

  pdfAvailable?: boolean;

  message?: string;

  constructor() {
    this.locationSet = false;
    this.reachable = false;
    this.writeAccess = false;
  }
}

/** The body of PUT settings/outputlocations/{purpose}; a listId of null unbinds the purpose. */
export class DocumentOutputLocationPutDTO {
  listId: number | null;

  templateLinkId: number | null;

  constructor() {
    this.listId = null;
    this.templateLinkId = null;
  }
}

/** The body of PUT settings/outputlocations/{purpose}/folder; a folderDriveItemId of null is the category root. */
export class DocumentOutputLocationFolderPutDTO {
  folderDriveItemId: string | null;

  folderName: string | null;

  constructor() {
    this.folderDriveItemId = null;
    this.folderName = null;
  }
}

export class DocumentOutputLocationSummaryDTO {
  purpose: number;

  listId?: number;

  listName?: string;

  providerType?: number;

  folderDriveItemId?: string;

  folderName?: string;

  constructor() {
    this.purpose = 0;
  }
}
